interface FormFieldProps {
  name: string
  label: string
  required?: boolean
  error?: string
  helperText?: string
  className?: string
  children: React.ReactNode
  showError?: boolean
  size?: 'sm' | 'md' | 'lg'
}

export const FormField = ({ 
  name, 
  label, 
  required, 
  error, 
  helperText, 
  className, 
  children, 
  showError = true,
  size: _size="md"
}: FormFieldProps) => {
  const labelSize = 'text-xs'
  const helperSize = 'text-xs'
  const spacingClass = 'mb-1.5'
  return (
    <div className={className}>
      {label && (
        <div className={spacingClass}>
          <label
            htmlFor={name}
            className={`block text-[var(--text-secondary)] font-medium ${labelSize}`}
          >
            {label} {required && <span className="text-[var(--status-error-text)]">*</span>}
          </label>
        </div>
      )}
      {children}
      {showError && error && (
        <p id={`${name}-error`} role="alert" className={`mt-1 text-xs text-[var(--status-error-text)]`}>
          {error}
        </p>
      )}
      {helperText && !error && (
        <p className={`mt-1 ${helperSize} text-[var(--text-secondary)]`}>
          {helperText}
        </p>
      )}
    </div>
  )
}